module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/person-placeholder-ff768.jpg";